export const FOREX_BROKERS_SLUG = 'brokers'

/**
 * Previously, we had a category page "/ForexBrokers" which was requested
 * to be changed to "/brokers/". We still use the legacy value for fetching
 * information from BE
 */
export const FOREX_BROKERS_SLUG_LEGACY = 'ForexBrokers'

export const COMPANY_CATEGORY_SLUG_BY_CATEGORY_SLUG = {
  [FOREX_BROKERS_SLUG_LEGACY]: 'brokers'
}

const COMPANY_CATEGORY_SLUG_BY_LOWERCASE_CATEGORY_SLUG = Object.entries(
  COMPANY_CATEGORY_SLUG_BY_CATEGORY_SLUG
).reduce((acc, [key, val]) => ({ ...acc, [key.toLowerCase()]: val }), {})

export function findCompanyCategorySlugByCategorySlug(category = '') {
  return COMPANY_CATEGORY_SLUG_BY_LOWERCASE_CATEGORY_SLUG[
    category.toLowerCase()
  ]
}
